import * as produitConf from '@/configuration/catalogue/produitConf';

function validationFaceAndLoc(dateDebut, dateFin, isCommandeBailleur, errors) {
  if (isCommandeBailleur && !dateDebut && !dateFin) {
    errors.push({
      message: 'dateDevis.error.pasDeDebutEtFin',
    });
  }
  if (!dateDebut && dateFin) {
    errors.push({
      message: 'dateDevis.error.pasDeDebut',
    });
  } else if (!dateFin && dateDebut) {
    errors.push({
      message: 'dateDevis.error.pasDeFin',
    });
  }
  return errors;
}

function validationNumerique(dateDebut, errors) {
  if (!dateDebut) {
    errors.push({
      message: 'dateDevis.error.pasDeDebut',
    });
  }
  return errors;
}

export default function validationDateLocation(
  dateDebut, dateFin, typeProduit, isCommandeBailleur = false,
) {
  const errors = [];
  switch (typeProduit) {
    case produitConf.CATEGORIE_UNITAIRE:
    case produitConf.CATEGORIE_LOCATION:
      validationFaceAndLoc(dateDebut, dateFin, isCommandeBailleur, errors); break;
    case produitConf.CATEGORIE_ECRAN_NUMERIQUE:
    case produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE:
      validationNumerique(dateDebut, errors);
      break;
    default: break;
  }
  if (dateDebut && dateFin) {
    if (dateDebut.getTime() > dateFin.getTime() || dateFin.getTime() < dateDebut.getTime()) {
      errors.push({
        message: 'dateDevis.error.debutSuperieurFin',
      });
    }
  }
  return errors;
}
